import React from "react";
import PropTypes from "prop-types";
import styles from "../../../../css/index.css";
const CopyrightSection = _ref => {
  let {
    copyrightText = `©1997-${new Date().getFullYear()} XO Group Inc.`
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.copyrightItem
  }, copyrightText);
};
process.env.NODE_ENV !== "production" ? CopyrightSection.propTypes = {
  copyrightText: PropTypes.string
} : void 0;
export default CopyrightSection;